import type { TwiageCase } from "@/App/types/twiageTypes";
import type { ActivatedProtocolResponse } from "@/Pages/Cases/ActivatedProtocolResponse";
import { updateCaseInTheList } from "@/Pages/Cases/store/updateCaseInTheList";
import { updateInList } from "@/App/utils/updateInList";

export const updateProtocolState = ({
  cases,
  caseId,
  result,
}: {
  cases: TwiageCase[];
  caseId: string;
  result: ActivatedProtocolResponse | null;
}): void => {
  if (result && result.activatedProtocol) {
    updateCaseInTheList({
      cases,
      caseId,
      getCaseUpdate: (caseToUpdate) => {
        updateInList({
          list: caseToUpdate.activatedProtocols,
          updatedItem: result.activatedProtocol,
          comparator: (l, r) => l._id === r._id,
        });
        return { activatedProtocols: caseToUpdate.activatedProtocols };
      },
    });
  }
};
